import React, { useState } from "react";
import "../styles/pages.css";
// Import images
import AdminDashboard from "../assets/images/AdminDashboard.png";
import Flyer from "../assets/images/Flyer.png";
import QRScan from "../assets/images/QRScan.jpg";
import sms from "../assets/images/sms.jpg";
import smsExcel from "../assets/images/smsExcel.jpg";
import smsPage from "../assets/images/smsPage.jpg";

function WaitingQ() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedAnalytics, setSelectedAnalytics] = useState(false);
  const [selectedRegistration, setSelectedRegistration] = useState(false);

  const handleAnalyticsClick = () => {
    setSelectedAnalytics(true);
  };

  const handleRegistrationClick = () => {
    setSelectedRegistration(true);
  };

  const handleModalClose = () => {
    setSelectedImage(null);
    setSelectedAnalytics(false);
    setSelectedRegistration(false);
  };

  return (
    <div className="page-container">
      <div className="hero-section">
        <h2 className="hero-title">WAITINGQ</h2>
        <p className="hero-subtitle">The Future of Queue Management</p>
      </div>

      <div className="features-section">
        <h3 className="section-title">Key Features</h3>
        <div className="features-grid">
          <div className="feature-item">
            <i className="feature-icon">📊</i>
            <h4>Real-time Queue Monitoring</h4>
            <p>Track and manage your queues in real-time</p>
          </div>
          <div className="feature-item">
            <i className="feature-icon">📱</i>
            <h4>Mobile Queue Registration</h4>
            <p>Easy registration through QR code scanning</p>
          </div>
          <div className="feature-item">
            <i className="feature-icon">💌</i>
            <h4>SMS Notification</h4>
            <p>Automated SMS alerts for queue status</p>
          </div>
          <div className="feature-item">
            <i className="feature-icon">📈</i>
            <h4>Analytics & Reports</h4>
            <p>Comprehensive data analysis and reporting</p>
          </div>
        </div>
      </div>

      <h3 className="section-title">System Preview</h3>
      <div className="image-gallery">
        <div
          className="gallery-item"
          onClick={() => setSelectedImage(AdminDashboard)}
        >
          <img src={AdminDashboard} alt="WaitingQ Dashboard" />
          <div className="gallery-item-overlay">
            <p>Real-time Queue Dashboard</p>
          </div>
        </div>
        <div
          className="gallery-item registration-process"
          onClick={handleRegistrationClick}
        >
          <div className="registration-images">
            <img src={Flyer} alt="QR Code Flyer" className="flyer-image" />
            <img
              src={QRScan}
              alt="Mobile Registration"
              className="qr-scan-image"
            />
          </div>
          <div className="gallery-item-overlay">
            <p>Easy Registration Process</p>
          </div>
        </div>
        <div className="gallery-item" onClick={() => setSelectedImage(sms)}>
          <img src={sms} alt="Notification Service with SMS" />
          <div className="gallery-item-overlay">
            <p>SMS Notification Service</p>
          </div>
        </div>
        <div className="gallery-item" onClick={handleAnalyticsClick}>
          <img src={smsPage} alt="Analytics View" />
          <div className="gallery-item-overlay">
            <p>Comprehensive Analytics</p>
          </div>
        </div>
      </div>

      {selectedImage && !selectedAnalytics && !selectedRegistration && (
        <div className="image-modal" onClick={handleModalClose}>
          <div className="modal-content">
            <img src={selectedImage} alt="Enlarged view" />
            <button className="close-button" onClick={handleModalClose}>
              ×
            </button>
          </div>
        </div>
      )}

      {selectedRegistration && (
        <div className="image-modal" onClick={handleModalClose}>
          <div className="modal-content registration-modal">
            <div className="registration-modal-images">
              <img src={Flyer} alt="QR Code Flyer" />
              <img src={QRScan} alt="Mobile Registration" />
            </div>
            <button className="close-button" onClick={handleModalClose}>
              ×
            </button>
          </div>
        </div>
      )}

      {selectedAnalytics && (
        <div className="image-modal" onClick={handleModalClose}>
          <div className="modal-content analytics-modal">
            <div className="analytics-images">
              <img src={smsPage} alt="Analytics Dashboard" />
              <img src={smsExcel} alt="Excel Reports" />
            </div>
            <button className="close-button" onClick={handleModalClose}>
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default WaitingQ;
